var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterSocial = function SvgTwitterSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8,
    cy: 24.8,
    r: 24.8,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M35.6 17.04a6.801 6.801 0 0 0 2.16-2.96c-1.111.53-2.3.881-3.52 1.04A5.76 5.76 0 0 0 24 18.72a6.81 6.81 0 0 0 .24 1.84c-8.56-.64-12-6.08-12-6.08s-2.08 4.32 1.28 7.76a3.76 3.76 0 0 1-1.92-.48s-.72 3.68 3.92 5.68a5.86 5.86 0 0 1-2 .16 6.24 6.24 0 0 0 5.28 4s-1.76 2.16-7.84 2.64a16.4 16.4 0 0 0 19.84-2.32s4.24-3.6 4.8-10.88l2.88-4.64-2.88.64z"
  }))));
};
export default SvgTwitterSocial;